"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function TikTokRedirectPage() {
  //  This page just redirects to landing and only serves to count visitors via the /tiktok link.
  const router = useRouter();

  useEffect(() => {
    router.push("/");
  }, [router]);

  return;
}
